import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ palette, breakpoints }) => ({
  faq: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    padding: `0 ${rem(16)}`,
    [breakpoints.up('md')]: {
      padding: `0 ${rem(20)}`,
    },
    [breakpoints.up('lg')]: {
      padding: `0 ${rem(80)}`,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    maxWidth: rem(1120),
    width: '100%',
    padding: `${rem(40)} 0`,
    [breakpoints.up('md')]: {
      padding: `${rem(60)} 0`,
    },
    [breakpoints.up('lg')]: {
      padding: `${rem(80)} 0`,
    },
  },
  title: {
    color: palette.neutral[100],
    textAlign: 'center',
    marginBottom: rem(36),
    [breakpoints.up('md')]: {
      marginBottom: rem(40),
    },
    [breakpoints.up('lg')]: {
      marginBottom: rem(60),
    },
  },
  strongText: {
    fontWeight: 500,
  },
}));
